import { POST_LOGIN_REDIRECT_KEY } from './postLoginRedirect';
import { AI_PROMPT_DISMISSALS_STORAGE_KEY } from './aiPromptDismissals';

const dataTableFilters = [
  'issuesColumnFilters',
  'topIssuesColumnFilters',
  'orgColumnFilters',
  'issuesDetailColumnFilters',
  'brokenLinksColumnFilters',
  'userPdfsColumnFilters',
  'foundPdfsColumnFilters',
  'pagesColumnFilters',
  'pageDetailColumnFilters',
  'spellCheckSitesColumnFilters',
  'lightHouseColumnFilters',
  'assistColumnFilters',
  'auditColumnFilters',
];

const dataTableSortings = [
  'issuesColumnSorting',
  'topIssuesColumnSorting',
  'orgColumnSorting',
  'issuesDetailColumnSorting',
  'brokenLinksColumnSorting',
  'userPdfsColumnSorting',
  'foundPdfsColumnSorting',
  'pagesColumnSorting',
  'pageDetailColumnSorting',
  'spellCheckSitesColumnSorting',
  'lightHouseColumnSorting',
  'assistColumnSorting',
  'auditColumnSorting',
];

const exceptions = [
  'logout',
  'eyeAbleVariables',
  'cookieBannerAccepted',
  'versionOfLastNotificationSeen',
  'notificationLastViewDate',
  'defaultMyGoalsBoardFilters',
  'i18nextLng',
  'userToursSeen',
  AI_PROMPT_DISMISSALS_STORAGE_KEY,
  ...dataTableFilters,
  ...dataTableSortings,
];

// The pending post-login target must outlive the wipe: the invited-user flow
// (forced password change) logs out between storing it and consuming it.
const sessionStorageExceptions = [POST_LOGIN_REDIRECT_KEY];

function clearStorageWithExceptions() {
  for (const key in localStorage) {
    if (!exceptions.includes(key)) {
      localStorage.removeItem(key);
    }
  }

  const keptSessionEntries = sessionStorageExceptions
    .map((key) => [key, sessionStorage.getItem(key)] as const)
    .filter(([, value]) => value !== null);

  sessionStorage.clear();

  for (const [key, value] of keptSessionEntries) {
    if (value !== null) sessionStorage.setItem(key, value);
  }
}

export default clearStorageWithExceptions;
